/**
 * Information about a payment method and its active registrations
 */
export type PaymentGuest = {
    masterGuestId: string;
    firstName: string;
    lastName: string;
    photoData: string;
}

export const getPaymentGuestDescription = (
  guest: PaymentGuest,
): string => {
    return (guest.firstName && guest.lastName)
        ?  `${guest.firstName} ${guest.lastName}` 
        : guest.masterGuestId;
}
      
